import React from 'react'
import Manager from '../../public/components/Manager'
import ObjectionDeductionDiv from './ObjectionDeductionDiv'
import BachConfirmDiv from './BachConfirmDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '发放月份', field: 'SalaryApply.Issue', minWidth: 250, search: true, },
        { _text: '员工编号', field: '_PersonNo', minWidth: 150, },
        { _text: '员工姓名', field: 'PersonName', minWidth: 150, flex: 10, search: true },
        { _text: '科目代码', minWidth: 150, flex: 10, search: true },
        { _text: '科目名称', minWidth: 150, search: true, },
        { _float: '加扣金额（元）', field: 'Amount', minWidth: 150, filter: true, },
        { _: 'taskName', field: '_TaskName' },
        {
            _button: '查看...', locked: 'right', icon: 'edit', minWidth: 120, handler: ({ showDetail, refreshPage }, data) => {
                Tyan.pubForm.showDialog('加扣项', props => <ObjectionDeductionDiv {...props} id={data.id} onFlowFinished={refreshPage} taskName={data.taskName} />)
            }
        },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
    }
}

export default props => <Manager {...props} config={config} />